import { render, staticRenderFns } from "./AwardsBottomPay.vue?vue&type=template&id=709780c2&scoped=true"
import script from "./AwardsBottomPay.vue?vue&type=script&lang=js"
export * from "./AwardsBottomPay.vue?vue&type=script&lang=js"
import style0 from "./AwardsBottomPay.vue?vue&type=style&index=0&id=709780c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709780c2",
  null
  
)

export default component.exports